<app-header-banner id="formResult" *ngIf="multiStepForm === 1"></app-header-banner>
<div fxShow fxHide.gt-md *ngIf="!showStripe && period && totalPremium"
     app-estimated-premium
     class="estimate-premium"
     (totalChangeLead)="totalChangePaymentLead($event)"
     [period]="period | lowercase"
     [total]="totalPremium">
</div>

<div class="guarantee_form_fxlayout guarantee_form_with_calculator">
  <div id="guaranteeContainer" class="guarantee_form_wrap">
    <!--<app-tab-switcher *ngIf="multiStepForm === 1"></app-tab-switcher>-->

    <app-residential-form
      [hidden]="multiStepForm !== 1"
      [live]="multiStepForm === 1"
      [loader]="loader"
      [residential]="residential"
      [policyApplicationId]="policyApplicationId"
      (periodChange)="period = $event"
      (totalChange)="estimateTotal($event)"
      (formSubmit)="submitForm($event)"
      (coverageOptionsInited)="coverageOptionsInited()"></app-residential-form>

      <ng-container *ngIf="multiStepForm === 2">
        <app-residential-payment
          [data]="secondResidentialObj"
          [residentialForm]="residential"
          [addressData]="addressData"
          [selectedPaymentPlan]="selectedPaymentPlan"
          [paymentPlans]="residentialFormComponent.billingStrategy"
          [loading]="paymentLoading"
          [hasBackButton]="brandingService.showBackButton$ | async"
          (paymentPlanChange)="changePaymentPlan($event)"
          (paymentSuccess)="createPaymentSuccessEvent()"
          (paymentError)="createPaymentErrorEvent()"
          (cardComplete)="trackCompleteCard($event)"
          (declinePayment)="back()"></app-residential-payment>
      </ng-container>
    </div>

  <div class="guarantee_component_wrap" fxHide fxShow.gt-md>
    <div *ngIf="!showStripe && period && totalPremium"
         app-estimated-premium
         class="estimate-premium"
         [period]="period | lowercase"
         (totalChangeLead)="totalChangePaymentLead($event)"
         [total]="totalPremium"></div>
  </div>
</div>


